import { render } from "./stageLine.vue?vue&type=template&id=13052138&scoped=true"
import script from "./stageLine.vue?vue&type=script&lang=js"
export * from "./stageLine.vue?vue&type=script&lang=js"

import "./stageLine.vue?vue&type=style&index=0&id=13052138&scoped=true&lang=less"

import exportComponent from "/web/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-13052138"]])

export default __exports__